export default __webpack_public_path__ + "static/media/AdminDarkInActive.86b131e3.svg";